import { useTheme } from '@common/theme-layer/composables/useTheme'

export default defineNuxtPlugin(() => {
  const { getStoredTheme, setTheme } = useTheme()

  setTheme(getStoredTheme())
})
